import { BasicEvent } from "./BasicEvent";
export class ArbetsorderOperationDeletedEvent extends BasicEvent {
    arbetsorderId: number;
    arbetsorderRowVersion: string;
    typ: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderOperationDeletedEvent";
    constructor() {
        super(ArbetsorderOperationDeletedEvent.$type);
    }
}
